import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thankyou-modal-component',
  templateUrl: './thankyou-modal-component.component.html',
  styleUrls: ['./thankyou-modal-component.component.sass']
})
export class ThankyouModalComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
